// extracted by mini-css-extract-plugin
module.exports = {"sliderList":"HorizontalSlider_sliderList__mb0Ov","fullwidth":"HorizontalSlider_fullwidth__VMzAu","horizontalSliderWrapper":"HorizontalSlider_horizontalSliderWrapper__dEtEJ"};